module.exports = __webpack_public_path__ + "static/media/gridIcon.7257fe0c.svg";